module.exports = __webpack_public_path__ + "assets/img/mecha-btn-38d01910.png";